/* globals jsVars */

function ajax({
  url,
  method = 'GET',
  params = {},
  async = true,
  done = function () {},
  error = function () {},
  always = function () {},
  responseType = 'json'
}) {
  const request = new XMLHttpRequest();
  request.responseType = responseType;
  request.onreadystatechange = function() {
    if ( request.readyState === 4 ) {
      always();
      if ( request.status === 200 ) {
        done( request.response );
      } else {
        error( request.response );
      }
    }
  }
  request.open( method, url, async );
  request.send( params );
}

function showMessage({message, typeAlert = 'success', content = ''}) {
  message.classList.add('active', typeAlert);
  message.textContent = content;

  setTimeout(() => {
    message.classList.remove('active', typeAlert);
    message.textContent = '';
  }, 5000);
}

( function( $ ) {
  const requireFieldMsg = 'Campo requerido';
  const emailMsg = 'El correo ingresado no es correcto';
  const minCharactersMsg = 'El mínimo de caracteres es {0}';
  const onlyNumberMsg = 'Debe ingresar sólo números';

  function registerContact() {
    const contactForm = $( '#js-contact-form' );

    if ( !contactForm ) {
      return;
    }

    $.validator.addMethod( 'onlyNumber', function( value, element) {
      return this.optional( element ) || /^\d+$/.test( value );
    });

    $.validator.addMethod( 'emailValid', function( value, element ) {
      return this.optional( element ) || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test( value );
    });

    contactForm.validate({
      rules: {
        name: {
          required: true,
          minlength: 3
        },
        lastname: {
          required: true,
          minlength: 3
        },
        company: {
          required: true,
          minlength: 3
        },
        job: {
          required: true,
          minlength: 3
        },
        email: {
          required: true,
          emailValid: true
        },
        phone: {
          required: true,
          onlyNumber: true
        },
        message: {
          required: true,
          minlength: 3
        }
      },
      messages: {
        name: {
          required: requireFieldMsg,
          minlength: $.validator.format( minCharactersMsg )
        },
        lastname: {
          required: requireFieldMsg,
          minlength: $.validator.format( minCharactersMsg )
        },
        company: {
          required: requireFieldMsg,
          minlength: $.validator.format( minCharactersMsg )
        },
        job: {
          required: requireFieldMsg,
          minlength: $.validator.format( minCharactersMsg )
        },
        email: {
          required: requireFieldMsg,
          email: emailMsg,
          emailValid: emailMsg
        },
        phone: {
          required: requireFieldMsg,
          onlyNumber: onlyNumberMsg
        },
        message: {
          required: requireFieldMsg,
          minlength: $.validator.format( minCharactersMsg )
        }
      },
      submitHandler: function ( form, ev) {
        ev.preventDefault();

        const formJs = document.getElementById( 'js-contact-form' );

        const loading = formJs.querySelector('.Form__loading');

        const message = formJs.querySelector('.Form__message');

        loading.classList.add('active', 'animate__animated');

        let formData = new FormData();

        formData.set('action', 'register_contact');
        formData.set('nonce', jsVars.nonce);
        formData.set('name', formJs.querySelector('input[name="name"]').value );
        formData.set('lastName', formJs.querySelector('input[name="lastname"]').value );
        formData.set('company', formJs.querySelector('input[name="company"]').value );
        formData.set('job', formJs.querySelector('input[name="job"]').value );
        formData.set('email', formJs.querySelector('input[name="email"]').value );
        formData.set('phone', formJs.querySelector('input[name="phone"]').value );
        formData.set('message', formJs.querySelector('textarea[name="message"]').value );

        // formData.set('terms', formJs.querySelector('input[name="terms"]').checked ? 'true' : 'false' );
        // formData.set('subscribe', formJs.querySelector('input[name="subscribe"]').checked ? 'true' : 'false' );

        ajax({
          url: jsVars.ajaxUrl,
          method: 'POST',
          params: formData,
          async: true,
          done: (response) => {
            showMessage({
              message,
              typeAlert: 'success',
              content: response.data
            });

            contactForm.reset();
          },
          error: (error) => {
            showMessage({
              message,
              typeAlert: 'danger',
              content: error.data
            });

            contactForm.reset();
          },
          always: () => {
            loading.classList.remove('active', 'animate__animated');
          }
        });
      }
    });
  }

  $( function() {
    registerContact();
  });
}( jQuery ));
